module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAABV0lEQVQ4jZWUPy8EURTFf7sZESISH0BCQ7MKBREV77aq1WhXFEqFQq/wHYSIL6DaZBPJfUIjap1aVKIRf0LsyE1m15r3zIzTTObdc8899/25tTRNicGJjAPLwCRQB+6Ba6/6FKETFXIix0DL4kEQzrzqen6xHhE5BTaBN2AXGAaGgG3gGWg6kXahIyfSAG6BF2DKqz7mioxmLU4AK1718i9H+9l3Jy9i8KqvwEaOGxWaA1KvehTszI/YOfAJzERbcyLzQDuz3QoUfuMQ+ADWvOpNX8iJ2M9iQK+GO686W1t1ztr7Ah6ATkArhgOm7VSTgX3qeNWtwrQcnMgBsAckwT2KkBtOZCEI5JAEKyEugBFgLIgMoNRRVqyUV0WoEqoI2Yl2g9WI7TI0AXtjpUK9avbKA3jVq4L8fk7vZpt9mz3vFRzmhSwv6bW2lM0bm4r/gY2bE6/a/QahQmUJYiizHgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/components/new-home/img/suo.png
// module id = I+WF
// module chunks = 0